<template>
    <div
        class="toast"
        @mouseover="clearTimeout"
        @mouseleave="timeout"
    >
        <div
            v-if="toast.image || toast.icon"
            class="image"
            :class="{'user-image': toast.userImage}"
        >
            <img v-if="toast.image" :src="toast.image" alt="">

            <div v-if="toast.icon" class="icon">
                <span :class="[toast.icon]"/>
            </div>
        </div>

        <div class="body">
            <span class="title">{{toast.title}}</span>
            <span class="text">{{toast.text}}</span>
        </div>
        <div class="actions">
            <button
                class="action-button"
                v-if="toast.closable"
                @click="close"
            >
                {{ $t('toast.close') }}
            </button>

            <button
                v-if="toast.action"
                class="action-button"
            >
                {{toast.actionTitle}}
            </button>

            <button
                v-if="toast.scrollTo"
                class="action-button"
                v-scroll-to="{el: toast.scrollTo, offset: -100}"
            >
                {{toast.actionTitle}}
            </button>

            <a
                v-if="toast.link"
                class="action-button"
                :href="toast.link"
            >
                {{toast.actionTitle}}
            </a>

            <button
                class="action-button"
                v-if="toast.reload"
                @click="reload"
            >
                {{ $t('toast.refresh') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['toast'],

    data () {
        return {}
    },

    mounted () {
        this.timeout()
    },

    methods: {
        close () {
            this.$toastStore.remove(this.toast.id);
        },

        clearTimeout () {
            clearTimeout(this.timeout);
        },

        timeout () {
            if (this.toast.autoClose) {
                this.timeout = setTimeout(this.close, this.toast.autoClose);
            }
        },

        reload () {
            window.location.reload();
        }
    }
}
</script>

<style scoped lang="postcss">
.toast {
    position: relative;
    display: flex;
    width: 100%;
    max-width: 480px;
    padding: 16px 18px;
    margin: 0 auto 16px;
    align-items: center;

    font-size: 12px;
    color: #fff;
    line-height: 16px;

    border-radius: 8px;
    background: var(--color-cases-toast);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    overflow: hidden;
    box-shadow: 0px 0px 1px var(--color-cases-shadow-border);

    transition: all .5s cubic-bezier(0.18, 0.89, 0.3, 1.08);

    &:hover {
        .actions {opacity: 1;}
    }
}

.body {
    flex-grow: 1;
    white-space: pre-line;
}

.title {
    font-weight: 700;
    white-space: pre-line;
}


.image {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 48px;
    min-height: 48px;

    margin-right: 16px;

    img {
        display: block;
        width: 100%;
    }

    .icon {
        width: 48px;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--color-cases-gray-2);

        border-radius: 50%;
        font-size: 18px;
    }
}

.actions {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;

    display: flex;
    flex-direction: column;

    opacity: 0;
    transition: opacity .25s ease;
}

.action-button {
    display: flex;
    flex-grow: 2;
    justify-content: center;
    align-items: center;

    padding: 4px 15px;

    background: var(--color-cases-black);

    border-radius: 0;

    border: none;
    border-left: 1px solid var(--color-cases-gray-2);

    outline: none;

    color: #fff;
    font-weight: 800;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;

    &+.action-button {
        border-top: 1px solid var(--color-cases-gray-2);
    }
}
</style>
